import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import scheduleReducer from "./schedule/slices";

const persistConfig = {
  key: "ners-mykoku",
  version: 1.5,
  storage,
};

export const rootReducer = combineReducers({
  schedule: scheduleReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof rootReducer>;

export const persistor = persistStore(store);
